export const WARE_STATUS = {
  COMING_SOON: -1,
  IN_STOCK: 0,
  OUT_OF_STOCK: 1,
  DISCONTINUED: 2,
  NOT_EXIST: 5, // 不存在
  BLACKLIST: 9, // 黑名单
  ABNORMAL: 10 // 异常
}
